export function defaultReportPeriod(now = new Date()) {
 const parts = new Intl.DateTimeFormat('en', {timeZone:'Europe/Moscow',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
 const part = (type: string) => parts.find(p => p.type === type)!.value;
 const today = `${part('year')}-${part('month')}-${part('day')}`;
 const next = new Date(today+'T00:00:00Z'); next.setUTCDate(next.getUTCDate()+1);
 return {from: today+'T00:00', to: next.toISOString().slice(0,10)+'T00:00'};
}
